import React from 'react';
import { Divider, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export type HeaderSummaryItem = {
  key: string;
  label: string;
  value: React.ReactNode;
  Icon?: React.ReactNode;
};

type Props = {
  items: HeaderSummaryItem[];
};

const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(2),
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: '3rem',
    marginBottom: '0.5rem',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      '& > p': {
        fontWeight: 'bold',
        margin: '0',

        '& > span': {
          display: 'block',
          fontWeight: 'normal',
          textTransform: 'capitalize',
        },
      },
    },
  },
}));

export function HeaderSummary({ items }: Props) {
  const classes = useStyles();

  return (
    <Paper className={classes.header}>
      {items.map((item, index) => (
        <React.Fragment key={item.key}>
          {index > 0 && <Divider style={{ height: '50px' }} orientation="vertical" light />}
          <div>
            {item.Icon}
            <p>
              {item.label} : <span>{item.value}</span>
            </p>
          </div>
        </React.Fragment>
      ))}
    </Paper>
  );
}
